export const personal = {
  name: "Riduvarshini R S",
  title: "Full-Stack Engineer · Go · React · Next.js · Cloud",
  email: "riduvarshinirs6@gmail.com",
  phone: "+91 8655345852",
  location: "Mumbai, India",
  university: "Amrita Vishwa Vidyapeetham",
  graduationYear: "2027",
  cgpa: "8.0",
  summary:
    "B.Tech CSE @ Amrita Vishwa Vidyapeetham. I architect and ship production-grade, scalable systems — including a fully dynamic National Cyber Police Portal handling 10,000+ real complaints daily. Passionate about high-throughput backends, clean APIs, and learning new stacks fast.",
  linkedin: "https://www.linkedin.com/in/riduvarshinirs/",
  github: "https://github.com/Riduvarshinirs",
};

export const stats = [
  { num: "2", label: "Gov. Internships" },
  { num: "5+", label: "Projects Shipped" },
  { num: "10K+", label: "Daily Complaints Handled" },
  { num: "8.0", label: "CGPA" },
];

export const experience = [
  {
    role: "Software Engineer Intern",
    company: "Ministry of Home Affairs, GOI · I4C — Indian Cyber Crime Coordination Center",
    period: "Dec 2025 – Feb 2026",
    location: "Delhi",
    featured: true,
    points: [
      "Architected and built the National Cyber Police Portal completely from scratch — a fully dynamic, production-grade system now receiving 10,000+ real citizen complaints every single day",
      "Modernized the portal from a legacy .NET monolith to a scalable React.js, Node.js, Express.js & PostgreSQL stack with role-based microservice-style separation",
      "Designed and implemented high-performance RESTful APIs routing live incident data to banks, accelerating Golden Hour fraud recovery windows",
      "Integrated an enterprise-scale PostgreSQL database with 200+ relational tables & 2,000+ stored procedures — deployed with zero downtime",
      "Enforced government-grade security: JWT authentication, RBAC, SQL injection prevention, and secure handling of sensitive citizen financial data",
      "Collaborated in an Agile environment with cross-functional teams to ensure on-time delivery of critical government infrastructure",
    ],
  },
  {
    role: "Software Engineer Intern",
    company: "Mazagon Dock Shipbuilders Ltd",
    period: "Apr 2025 – May 2025",
    location: "Mumbai",
    featured: false,
    points: [
      "Enhanced a live government website on the DBIM Toolkit using .NET, C#, SCSS, and MySQL",
      "Implemented secure login with CAPTCHA, reducing bot-based authentication attacks",
      "Applied OWASP, WCAG 2.2, and GIGW 3.0 compliance standards — ensuring accessibility and security at scale",
      "Worked with enterprise infrastructure: Networking, DLP, Firewalls, and Email Systems",
    ],
  },
];

export const projects = [
  {
    icon: "🏛️",
    iconBg: "rgba(99,179,237,0.12)",
    name: "National Cyber Police Portal — Live Gov. System",
    event: "I4C · Ministry of Home Affairs · Dec 2025",
    desc: "Built end-to-end from scratch — a fully dynamic, scalable web portal for the 1930 Cyber Helpline. Handles 10,000+ real complaints daily from citizens across India. React.js frontend, Node.js/Express.js backend, PostgreSQL with 200+ tables, role-based access control, and high-performance REST APIs routed to banks for real-time fraud recovery.",
    tags: ["React.js", "Node.js", "PostgreSQL", "REST APIs", "RBAC", "Express.js"],
    highlight: true,
  },
  {
    icon: "🔍",
    iconBg: "rgba(99,179,237,0.1)",
    name: "Financial Crime Detection Engine",
    event: "RIFT Hackathon · Feb 2026",
    desc: "Graph-based fraud detection processing 10,000+ transactions in under 30 seconds. DFS cycle detection, smurfing pattern analysis via fan-in/fan-out graph analysis, and a 0–100 suspicion scoring engine achieving ≥70% precision and ≥60% recall.",
    tags: ["Graph Theory", "DFS", "Full-Stack", "Python", "REST APIs"],
  },
  {
    icon: "🏦",
    iconBg: "rgba(159,122,234,0.12)",
    name: "Early Warning & Contagion Detection in Financial Networks",
    event: "Social Network Analytics · Nov 2025",
    desc: "GNN-based systemic risk framework on an 82-bank, 410-edge interbank exposure graph. Combined SNA metrics (degree, betweenness, eigenvector centrality), threshold-based and balance-sheet cascade contagion models, and GraphSAGE/GCN/GAT architectures. GNN converged to loss 0.013 with predictions strongly aligned to contagion outcomes.",
    tags: ["GNN", "GraphSAGE", "GCN", "GAT", "Python", "NetworkX", "PyTorch"],
  },
  {
    icon: "🗺️",
    iconBg: "rgba(79,209,197,0.1)",
    name: "TravShield — AI Smart Tourism Platform",
    event: "Smart India Hackathon · Aug 2025",
    desc: "5-agent LangGraph multi-agent system with BERT/RoBERTa Critic Agent for spot validation, Google OR-Tools route optimizer balancing cost, time & eco-friendliness, and PyTorch risk model with Twilio real-time safety alerts.",
    tags: ["LangGraph", "LangChain", "BERT", "PyTorch", "Twilio"],
  },
  {
    icon: "🌱",
    iconBg: "rgba(159,122,234,0.1)",
    name: "SUTRA — Community Sustainability App",
    event: "ICSRF 2025 · Aug 2025",
    desc: "IoT + AI + GIS platform with ESP32/Arduino sensors for real-time rural monitoring. Village Sustainability Index across 5 dimensions with multilingual voice reporting eliminating literacy barriers for 650M+ rural Indians.",
    tags: ["IoT", "Raspberry Pi", "GIS", "TensorFlow"],
  },
  {
    icon: "🌿",
    iconBg: "rgba(72,187,120,0.1)",
    name: "Carbon Footprint Tracker",
    event: "Vidyut Fest 2025 · 🏆 1st Place",
    desc: "Flutter mobile app tracking real-time carbon emissions with personalized dashboards. Firebase Authentication & Firestore for secure user management and cloud data storage.",
    tags: ["Flutter", "Firebase", "Firestore"],
  },
];

export const certifications = [
  {
    name: "AWS APAC - Solutions Architecture Job Simulation",
    issuer: "Forage",
    date: "Dec 2024",
    credentialId: "YY2RwCcGDNheohmWh",
  },
  {
    name: "JPMorgan Chase & Co. Excel Skills Job Simulation",
    issuer: "Forage",
    date: "Aug 2024",
    credentialId: "8d4byXrCq8Qv8SaSq",
  },
  {
    name: "Introduction to Responsible AI",
    issuer: "Google Cloud",
    date: "Jul 2024",
    credentialId: "10244206",
  },
  {
    name: "Introduction to Generative AI",
    issuer: "Google Cloud",
    date: "Jul 2024",
    credentialId: "9755938",
  },
  {
    name: "AI/ML",
    issuer: "ISRO",
    date: "2024",
    credentialId: null,
  },
  {
    name: "Cloud Computing",
    issuer: "Scaler",
    date: "2024",
    credentialId: null,
  },
];

export const spokenLanguages = [
  { language: "Tamil", proficiency: "Native" },
  { language: "English", proficiency: "Professional" },
  { language: "Hindi", proficiency: "Professional" },
  { language: "Marathi", proficiency: "Professional" },
  { language: "Malayalam", proficiency: "Limited Working" },
  { language: "Sanskrit", proficiency: "Elementary" },
  { language: "Telugu", proficiency: "Fundamental" },
];

export const skills = [
  {
    category: "Languages",
    items: ["Go (Golang)", "JavaScript", "Python", "C++", "Java", "C#", "SQL"],
  },
  {
    category: "Frontend",
    items: ["React.js", "Next.js", "HTML", "CSS", "SCSS", "Flutter"],
  },
  {
    category: "Backend & APIs",
    items: ["Node.js", "Express.js", ".NET", "RESTful APIs", "Microservices"],
  },
  {
    category: "Database & Cache",
    items: ["PostgreSQL", "MySQL", "Redis", "SQL", "Firebase", "Stored Procedures"],
  },
  {
    category: "DevOps & Cloud",
    items: ["Docker", "Kubernetes", "CI/CD", "MS Azure", "AWS", "Git"],
  },
  {
    category: "Security & Standards",
    items: ["OWASP", "RBAC", "JWT", "WCAG 2.2", "CAPTCHA", "GIGW 3.0"],
  },
  {
    category: "AI / ML",
    items: ["LangChain", "LangGraph", "PyTorch", "TensorFlow", "BERT", "GNN"],
  },
  {
    category: "Other",
    items: ["Agile / Scrum", "IoT / Arduino", "GIS", "Twilio", "Testing Frameworks"],
  },
];
